import React from 'react'
import {MdInfoOutline} from 'react-icons/md'
import Box from '@material-ui/core/Box'

export const headerTooltip = {
  image: <MdInfoOutline size={22} />,
  colorTransparent: true,
  title:
    "Asset Panda's built in barcode generator software allows you to create barcode designs to print onto labels, allowing you to scan and search within your account for items with a click of a button.",
}

export const automaticTooltip = {
  image: <MdInfoOutline size={26} />,
  colorTransparent: false,
  title: (
    <div>
      <Box>Output</Box>
      <Box fontWeight={350} fontSize={12}>
        If 'PNG' is selected, each label will be separate. PNG file and all will be included in a
        ZIP archive.
      </Box>
      <Box marginTop={3}>Label Template</Box>
      <Box fontWeight={350} fontSize={12}>
        Labels that contain fields are not visible until Data Source is "With value from Group
        field" and you select the right Group.
      </Box>
      <Box marginTop={3}>Digits</Box>
      <Box fontWeight={350} fontSize={12}>
        Number of characters for the code, prefix included.
      </Box>
    </div>
  ),
}

export const fieldValueTooltip = {
  image: <MdInfoOutline size={26} />,
  colorTransparent: false,
  title: (
    <div>
      <Box>Output</Box>
      <Box fontWeight={350} fontSize={12}>
        If 'PNG' is selected, each label will be separate. PNG file and all will be included in a
        ZIP archive.
      </Box>
      <Box marginTop={3}>Label Template</Box>
      <Box fontWeight={350} fontSize={12}>
        Labels that contain fields are not visible until Data Source is "With value from Group
        field" and you select the right Group.
      </Box>
    </div>
  ),
}

export const editOutputTooltip = {
  image: <MdInfoOutline size={12} />,
  colorTransparent: false,
  title: (
    <div>
      <Box>Output</Box>
      <Box fontWeight={350} fontSize={12}>
        If 'PNG' is selected, each label will be separate. PNG file and all will be included in a
        ZIP archive.
      </Box>
    </div>
  ),
}
